import NavTab from '../nav-main/src/v2/nav-tab';

/* istanbul ignore next */
NavTab.install = function(Vue) {
  Vue.component(NavTab.name, NavTab);
};

export default NavTab;
